import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userPlaceholder from "assets/img/user-placeholder.jpg";
import { storeAuth } from "store/slices/authSlice";
import { Link, useNavigate } from "react-router-dom";

const Header = ({ isSidebarShown, setIsSidebarShown }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isDropboxOpen, setIsDropboxOpen] = useState(false);
  const { auth } = useSelector((state) => state.auth);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    localStorage.removeItem("user-auth");
    dispatch(storeAuth({}));
    navigate("/login");
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropboxOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <header>
      <div className="d-flex">
        {!isSidebarShown && (
          <Link to="/" className="logo m-0">
            <img src={require("assets/img/logo.png")} alt="JagahDekho" width={40} />
          </Link>
        )}
        <button
          type="button"
          className="sidebar-toggler"
          onClick={() => setIsSidebarShown((p) => !p)}
        >
          <i className="bi bi-list"></i>
        </button>
      </div>
      <div className="d-flex align-items-center">
        <div className=" user-profile-img">
          <div className="theme-img">
            <img
              src={auth?.profile || userPlaceholder}
              onError={(e) => {
                e.target.src = userPlaceholder;
              }}
              alt="P"
            />
          </div>
        </div>
        <div className="drop-box-cover" ref={dropdownRef}>
          <button
            type="button"
            className="user-profile-btn"
            onClick={() => setIsDropboxOpen((p) => !p)}
          >
            <h6 className="mb-0">{auth?.name}</h6>
            <small className="text-muted">{auth?.email}</small>
          </button>
          {isDropboxOpen && (
            <div className="profile-dropbox drop-box">
              <button
                type="button"
                onClick={handleLogout}
                className="text-danger d-flex align-items-center"
              >
                <i className="bi bi-box-arrow-right me-2 fs-20"></i>Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
